import { Injectable } from '@angular/core';
import { PortalFieldConfig, uppercaseParser } from '@portal/form/data-access';

@Injectable({ providedIn: 'root' })
export class SendingOtpFormConfigService {
  initSendingOtpFormFields(): PortalFieldConfig[] {
    return [
      {
        key: 'appId',
        type: 'input',
        hide: true,
        props: {
          label: 'Application ID',
          placeholder: 'eg. P-XXXX',
          required: true,
          disabled: true,
          alwaysShowMandatoryMarker: true,
          maskConfig: {
            mask: 'S-A*',
            config: { dropSpecialCharacters: false },
          },
        },
        parsers: [uppercaseParser],
        validators: { validation: ['application-id'] },
        validation: { messages: { required: () => 'Please enter your Application ID.' } },
      },
      {
        key: 'otpCode',
        type: 'otp',
        props: {
          label: 'Please enter your 6-digit OTP',
          otpConfig: { length: 6, allowNumbersOnly: true },
          required: true,
          minLength: 6,
        },
      },
      {
        key: 'last4NRIC',
        type: 'input',
        props: {
          hidden: true,
        },
        expressions: {
          hide: '!model.name',
        },
      },
    ];
  }
}
